<div *ngIf="moduleAccess">
  <div class="w-100 bg-lavendar mt-80">
    <app-header></app-header>
  </div>

  <div class="bg-color p-3">
    <div class="row">
      <div class="col-sm-2">
        <div class="single-left-pane">
          <app-side-menu></app-side-menu>
        </div>
      </div>
      <div class="col-sm-7 p-0">
        <div class="single-center-pane">
          <div class="container">
            <h6 style="margin-bottom: 40px">
              {{ authText.access_denied_text }}
            </h6>
            <img
              src="./assets/images/access_denied.svg"
              width="200px"
              alt="Access Denied"
            />
            <h6 style="margin-top: 10px">
              {{ authText.access_denied }}
            </h6>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="single-right-pane">
          <app-gnews></app-gnews>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</div>
<div
  *ngIf="!moduleAccess"
  class="d-flex justify-content-center align-items-center mt-80"
  style="height: 50vh"
>
  <div class="text-center">
    <h6 style="margin-bottom: 40px">{{ authText.access_denied_text }}</h6>
    <img
      src="./assets/images/access_denied.svg"
      width="200px"
      alt="Access Denied"
    />
    <h6 style="margin-top: 10px">{{ authText.access_denied_caption }}</h6>
    <h6 style="margin-top: 10px">{{ authText.contact_admin }}</h6>
  </div>
</div>
